import { RemoveCircleOutlineRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

interface RemoveFromCollectionButtonProps {
  removeFromCollection: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const RemoveFromCollectionButton = ({
  removeFromCollection,
}: RemoveFromCollectionButtonProps) => {
  return (
    <Button
      variant="text"
      color="error"
      startIcon={<RemoveCircleOutlineRounded />}
      size="small"
      onClick={removeFromCollection}
    >
      Remove
    </Button>
  );
};
